import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { MessageType, QueryParamsModel } from '../../_base/crud';
import { Note } from '../_models/note.model';

export enum NoteActionTypes {
  ToggleNotePageLoading = '[Note] Toggle Note Page Loading',
  ToggleNoteActionLoading = '[Note] Toggle Note Action Loading',
  RequestNotePage = '[Note] Request Note Page',
  LoadNotePage = '[Note] Load Note Page',
  CancelNotePage = '[Note] Cancel Note Page',
  CreateNote = '[Note] Create Note',
  CreateNoteOnServer = '[Note] Create Note On Server',
  UpdateNote = '[Note] Update Note',
  UpdateNoteOnServer = '[Note] Update Note On Server',
  DisplayNoteMessage = '[Note] Display Note Message',
  ThrowNoteError = '[Note] Throw Note Error',
  ClearNoteError = '[Note] Clear Note Error',
}

export class ToggleNotePageLoading implements Action {
  readonly type = NoteActionTypes.ToggleNotePageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleNoteActionLoading implements Action {
  readonly type = NoteActionTypes.ToggleNoteActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestNotePage implements Action {
  readonly type = NoteActionTypes.RequestNotePage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadNotePage implements Action {
  readonly type = NoteActionTypes.LoadNotePage;

  constructor(public payload: { notes: Note[]; totalCount: number; query: QueryParamsModel }) {}
}

export class CancelNotePage implements Action {
  readonly type = NoteActionTypes.CancelNotePage;
}

export class CreateNote implements Action {
  readonly type = NoteActionTypes.CreateNote;

  constructor(public payload: { note: Note }) {}
}

export class CreateNoteOnServer implements Action {
  readonly type = NoteActionTypes.CreateNoteOnServer;

  constructor(public payload: { note: Note; close(dialogResult?: any): void }) {}
}

export class UpdateNote implements Action {
  readonly type = NoteActionTypes.UpdateNote;

  constructor(public payload: { note: Update<Note> }) {}
}

export class UpdateNoteOnServer implements Action {
  readonly type = NoteActionTypes.UpdateNoteOnServer;

  constructor(public payload: { note: Note; close(dialogResult?: any): void }) {}
}

export class DisplayNoteMessage implements Action {
  readonly type = NoteActionTypes.DisplayNoteMessage;

  constructor(public payload: { message: string; messageType: MessageType }) {}
}

export class ThrowNoteError implements Action {
  readonly type = NoteActionTypes.ThrowNoteError;

  constructor(public payload: { error: any }) {}
}

export class ClearNoteError implements Action {
  readonly type = NoteActionTypes.ClearNoteError;
}

export type NoteActions =
  | ToggleNotePageLoading
  | ToggleNoteActionLoading
  | RequestNotePage
  | LoadNotePage
  | CancelNotePage
  | CreateNote
  | CreateNoteOnServer
  | UpdateNote
  | UpdateNoteOnServer
  | DisplayNoteMessage
  | ThrowNoteError
  | ClearNoteError;
